module.exports = __webpack_public_path__ + "img/Sabun Habis Icon.63cefa02.png";